import moment from 'moment'
import axios from '../../../axios'

export const workReportsMixin = {
  methods: {
    /*retrieve filtered reports methods*/

    async getReportsAndFilterByWeek() {
      // Filtering on the reports should be done after they're loaded
      await this.retrieveWorkReports()

      // copy the fetched data from the api -> needed because otherwise it would get lost if we filter it
      this.copyEntriesToTableData()
      this.filterOnWeek(this.$store.getters['authentication/getCurrentWeek'], { data: this.tableData, dateColumn: 'task_start' })
    },

    async getReportsAndFilterByWeekAndUserId() {
      // Filtering on the reports should be done after they're loaded
      await this.retrieveAllWorkReports()

      // copy the fetched data from the api -> needed because otherwise it would get lost if we filter it
      this.copyEntriesToTableData()

      this.filterOnWeek(this.week, { data: this.tableData, dateColumn: 'date' })
      this.filterOnUserId('author student work reports', this.userId)
    },

    async getCommentsAndFilterByWeekVisibilityAndTargetId(groups = 'supervisors') {
      const visiblity = groups === 'supervisors' ? [1, 2] : [2]

      // Filtering on the reports should be done after they're loaded
      await this.retrieveWorkReportsComments()
      await this.mapUserIdToName()

      // copy the fetched data from the api -> needed because otherwise it would get lost if we filter it
      this.copyEntriesToTableData()

      this.filterOnWeek(this.week, { data: this.tableData, dateColumn: 'date' })
      this.filterOnVisibility(visiblity, this.getUserId)
      this.filterOnUserId('target student work reports', this.userId)

      this.sortByDateDesc({ data: this.tableData, dateColumn: 'date' })
    },

    /*api call methods*/

    async retrieveWorkReports() {
      const responseProjectId = this.getProjectId
      const config = {
        params: {
          project_id: responseProjectId
        }
      }
      const response = await axios.get('work-reports', config)
      this.fetchedData = response.data.filter((entry) => entry.author === this.getUserId)
    },

    async retrieveAllWorkReports() {
      const responseProjectId = await this.getProjectId

      const config = {
        params: {
          project_id: responseProjectId
        }
      }
      const response = await axios.get('work-reports', config)
      this.fetchedData = response.data
    },

    async retrieveWorkReportsComments() {
      const responseProjectId = await this.getProjectId

      const config = {
        params: {
          project_id: responseProjectId
        }
      }
      const response = await axios.get('work-report-comments', config)
      this.fetchedData = response.data
    },

    /*work hour methods*/

    getWorkHoursPerWeek(data, weekNumber = undefined) {
      const entries =
        weekNumber == undefined //eslint-disable-line
          ? data
          : data.filter((item) => parseInt(this.getWeekNumber(item.task_start)) === parseInt(weekNumber))

      return entries.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.task_duration
      }, 0)
    },

    getWorkHoursPerWeekAndByUserId(data, weekNumber = undefined, userId) {
      const entries =
        weekNumber == undefined //eslint-disable-line
          ? data.filter((item) => item.author === parseInt(userId))
          : data.filter(
              (item) => parseInt(this.getWeekNumber(new Date(item.task_start))) === parseInt(weekNumber) && item.author === parseInt(userId)
            )

      return entries.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.task_duration
      }, 0)
    },

    /*table helper methods*/

    copyEntriesToTableData() {
      this.tableData = this.fetchedData.map((item) => ({
        ...item,
        isEdit: false,
        isDelete: false,
        weekNumber: this.getWeekNumber(new Date(item.task_start === undefined ? item.date : item.task_start)),
        fullName: this.idToName !== undefined ? this.idToName[item.author] : '',
        readOnly: item.author !== this.getUserId,
        options:
          item.visibility !== undefined
            ? [
                { text: this.$i18n.t('VISIBILITY.ONLY_ME'), value: 0 },
                { text: this.$i18n.t('VISIBILITY.SUPERVISORS_ONLY'), value: 1 },
                { text: this.$i18n.t('VISIBILITY.SUPERVISORS_AND_STUDENTS'), value: 2 }
              ]
            : null
      }))
    },

    /*validation methods*/

    isDateNotOlderThanThisWeek(entry) {
      return !(
        moment(this.tableData[entry.index].task_start).isSameOrAfter(moment(this.minDate).startOf('day')) &&
        moment(this.tableData[entry.index].task_start).isSameOrBefore(moment(this.maxDate).endOf('day'))
      )
    }
  }
}
